import { sfGet } from "./salesforceApi";
import { getEnv } from "../config/getEnv";

const PAGEUTILS_RESOURCE =
  getEnv("REACT_APP_SF_PAGEUTILS_RESOURCE") || "/PageUtils";

/**
 * Fetch consolidated Project Page preview data from the PageUtils Apex REST.
 * @param {object} args
 * @param {string} args.projectObjectiveId - PO Id (poid)
 * @param {"PreQualPage"|"ActivePage"} args.pageType - Page type selector
 */
export async function fetchProjectPagePreview({
  projectObjectiveId,
  pageType,
}) {
  if (!projectObjectiveId)
    throw new Error("fetchProjectPagePreview requires a projectObjectiveId");
  if (!pageType) throw new Error("fetchProjectPagePreview requires a pageType");

  // The HTTP layer unwraps the envelope and returns the inner `data` object
  // when `success === true`.
  return sfGet(`${PAGEUTILS_RESOURCE}`, {
    poid: String(projectObjectiveId),
    pagetype: String(pageType),
  });
}
